import EvalCompletadas from "pages/LandingPages/EvalCompletadas/evalCompletadas";

export default function EvalCompletadasPage() {
  return <EvalCompletadas />;
}
